import "select2/dist/css/select2.css"
import * as select2 from "select2/dist/js/select2"